import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { GoogleSheetsBaseService } from './google-sheets-base.service';

@Injectable({
  providedIn: 'root'
})
export class CoiSheetsService extends GoogleSheetsBaseService {

  /**
   * Gets a list of coverage types from the 'coi' sheet.
   * @returns An observable of the coverage types.
   */
  getCoverageTypes(): Observable<any> {
    const tabName = 'coi';
    const startCell = 'A2';
    const endCell = 'A30';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }
}